import type { Dictionary } from "../dictionary";

const ar: Dictionary = {
  meta: {
    siteName: "Tetri Software",
    defaultTitle: "Tetri Copilot LLC — برمجيات أعمال ذكية",
    defaultDescription:
      "تبني Tetri Copilot LLC عائلة Tetri من برمجيات الأعمال الذكية — Tetri Copilot وTetri Engage — وتقدّم خدمات مختارة في تطوير البرمجيات والذكاء الاصطناعي وتطوير المواقع.",
  },

  nav: {
    home: "الرئيسية",
    products: "المنتجات",
    services: "الخدمات",
    company: "الشركة",
    contact: "تواصل معنا",
    productsMenu: {
      copilot: "Tetri Copilot",
      copilotHint: "الشؤون المالية والتشغيل بلا تعقيد",
      engage: "Tetri Engage",
      engageHint: "فرص مرتّبة حسب الأولوية",
      viewAll: "عرض جميع المنتجات",
    },
    cta: "استكشف المنتجات",
    openMenu: "فتح القائمة",
    closeMenu: "إغلاق القائمة",
    languageLabel: "اللغة",
    skipToContent: "الانتقال إلى المحتوى",
  },

  footer: {
    tagline: "تبني Tetri Copilot LLC برمجيات ذكية تساعد الشركات على العمل والتواصل مع عملائها والنمو بأقل قدر من التعقيد.",
    productsHeading: "المنتجات",
    servicesHeading: "الخدمات",
    companyHeading: "الشركة",
    legalHeading: "الشؤون القانونية",
    company: {
      about: "من نحن",
      services: "الخدمات",
      contact: "تواصل معنا",
      partnerships: "الشراكات",
    },
    legal: {
      privacy: "سياسة الخصوصية",
      terms: "شروط الخدمة",
      cookies: "سياسة ملفات تعريف الارتباط",
    },
    rights: "جميع الحقوق محفوظة.",
    registeredNote: "شركة Tetri Copilot LLC مسجّلة في جورجيا.",
  },

  productPanel: {
    copilotTitle: "نظرة عامة على مساحة العمل",
    engageTitle: "نظرة عامة على المسار",
    copilotRows: [
      { label: "فاتورة · العميل أ", status: "أُرسلت" },
      { label: "فاتورة · العميل ب", status: "مدفوعة" },
      { label: "مصروف · سفر", status: "مسجَّل" },
    ],
    engageRows: [
      { label: "فرصة · إشارة أ", status: "جديدة" },
      { label: "فرصة · إشارة ب", status: "مؤهَّلة" },
      { label: "متابعة · إشارة ج", status: "اليوم" },
    ],
    copilotScreenshotAlt:
      "لوحة Tetri Copilot تعرض الإيرادات والفواتير المستحقة وصافي النقد ومخطط التدفق النقدي",
    engageScreenshotAlt:
      "مسار فرص Tetri Engage يعرض العملاء المحتملين المُقيَّمين بالذكاء الاصطناعي وإجراء متابعة تم إنشاؤه تلقائيًا",
  },

  common: {
    buttons: {
      exploreProducts: "استكشف المنتجات",
      contactUs: "تواصل معنا",
      talkToUs: "تحدث إلينا",
      learnMore: "اعرف المزيد",
      visitProduct: "زيارة المنتج",
      discussProject: "ناقش مشروعك",
      sendMessage: "إرسال الرسالة",
      viewAllProducts: "عرض جميع المنتجات",
      backHome: "العودة إلى الرئيسية",
      viewServices: "عرض الخدمات",
      readMore: "اقرأ المزيد",
    },
    badges: {
      live: "متاح",
      beta: "تجريبي",
      comingSoon: "قريبًا",
    },
    labels: {
      capabilities: "الإمكانات",
      builtFor: "مصمَّم لأجل",
      relatedProducts: "منتجات ذات صلة",
    },
  },

  seo: {
    home: {
      title: "Tetri Software — برمجيات أعمال ذكية للشركات الصغيرة والمتوسطة",
      description: "برمجيات أعمال مدعومة بالذكاء الاصطناعي للشركات المتنامية في الإمارات والسعودية وجورجيا والولايات المتحدة وحول العالم: Tetri Copilot وTetri Engage.",
    },
    products: {
      title: "برمجيات الأعمال: Tetri Copilot وTetri Engage | Tetri Software",
      description: "قارن بين Tetri Copilot للفواتير والمصروفات والامتثال، وTetri Engage لاكتشاف العملاء المحتملين والمتابعات. مصمَّمة للشركات الصغيرة والمتوسطة والفرق المتنامية.",
    },
    copilot: {
      title: "Tetri Copilot: برنامج فواتير وإدارة للشركات الصغيرة | Tetri Software",
      description: "الفواتير والمصروفات وسجلات الأعمال ومتابعة الامتثال والتقارير في مساحة عمل واحدة بمساعدة الذكاء الاصطناعي، للشركات في الإمارات والسعودية وجورجيا والولايات المتحدة.",
    },
    engage: {
      title: "Tetri Engage: اكتشاف العملاء ومتابعتهم بالذكاء الاصطناعي | Tetri Software",
      description: "اعثر على الفرص الواعدة، ورتّب العملاء المحتملين بتقييم الذكاء الاصطناعي، وأبقِ كل متابعة في مسارها. لفرق المبيعات في الإمارات والسعودية وجورجيا والولايات المتحدة.",
    },
    services: {
      title: "تطوير البرمجيات والذكاء الاصطناعي والمواقع | Tetri Software",
      description: "تطوير منتجات SaaS وأتمتة بالذكاء الاصطناعي وتطبيقات ويب ومواقع من الفريق الذي يبني Tetri Copilot وTetri Engage، لعملاء في الإمارات والسعودية وجورجيا والولايات المتحدة.",
    },
    about: {
      title: "عن Tetri Copilot LLC | Tetri Software",
      description: "Tetri Copilot LLC شركة برمجيات مسجّلة في جورجيا، تبني عائلة منتجات Tetri للشركات في الإمارات والسعودية والولايات المتحدة وحول العالم.",
    },
    contact: {
      title: "تواصل مع Tetri | Tetri Software",
      description: "لديك سؤال عن Tetri Copilot أو Tetri Engage أو شراكة أو مشروع برمجي؟ تواصل مع فريق Tetri عبر البريد الإلكتروني أو الهاتف أو نموذج التواصل.",
    },
  },

  home: {
    hero: {
      heading: "برمجيات صُممت لتبسيط الأعمال.",
      subheading:
        "تبني Tetri منتجات أعمال مركّزة. يدير Tetri Copilot الشؤون المالية والإدارية، ويكتشف Tetri Engage الفرص ويتابعها، ويتولى الفريق الذي يقف خلفهما عددًا مختارًا من مشاريع العملاء.",
      ctaPrimary: "استكشف المنتجات",
      ctaSecondary: "تحدث إلينا",
    },
    stage: {
      copilot: {
        description: "الفواتير والمصروفات والسجلات ومتابعة الامتثال والتقارير في مساحة عمل واحدة.",
        cta: "استكشف Tetri Copilot",
      },
      engage: {
        description: "اكتشاف العملاء المحتملين وتقييم الفرص ومتابعات لا تضيع.",
        cta: "استكشف Tetri Engage",
      },
    },
    work: {
      heading: "تولّد إدارة الأعمال مهامًا أكثر مما يستطيع أي فريق مواكبته.",
      body: "يتولى كل منتج من Tetri جزءًا من هذا العمل ويحوّله إلى مسار عمل مركّز وذكي، فيقضي فريقك وقتًا أقل في إدارة الأنظمة.",
      listLabel: "أين يذهب العمل",
      items: [
        { problem: "سجلات وفواتير ومهام امتثال متناثرة بين أدوات متعددة", product: "copilot" },
        { problem: "تقارير يُعاد إعدادها يدويًا كل شهر", product: "copilot" },
        { problem: "فرص واعدة تضيع وسط الضجيج", product: "engage" },
        { problem: "متابعات تُنسى دون أن يلاحظ أحد", product: "engage" },
      ],
    },
    copilot: {
      heading: "إدارة أعمال لا تقف في طريقك.",
      body: "مساحة عمل حديثة واحدة للجانب الإداري من العمل، مع ذكاء اصطناعي يتولى المهام المتكررة.",
      capabilities: ["الفواتير", "المصروفات", "سجلات الأعمال", "متابعة الامتثال", "التقارير", "مساعدة الذكاء الاصطناعي"],
      cta: "استكشف Tetri Copilot",
    },
    engage: {
      heading: "من الإشارة إلى المتابعة، بجهد يدوي أقل.",
      body: "يساعد Tetri Engage الفرق المتنامية على إيجاد الفرص الواعدة، وتحديد الأهم منها، والإبقاء على كل متابعة في مسارها.",
      steps: [
        { title: "تظهر إشارة", description: "يرصد Engage نشاطًا يستحق نظرة أقرب." },
        { title: "تُقيَّم الفرصة", description: "يرتّبها الذكاء الاصطناعي ليبدأ الفريق بأقوى الفرص." },
        { title: "تُنشأ متابعة", description: "تصل الخطوة التالية إلى قائمة الشخص المناسب." },
      ],
      cta: "استكشف Tetri Engage",
    },
    ai: {
      heading: "يجب أن يزيل الذكاء الاصطناعي العمل، لا أن يضيف نظامًا جديدًا لإدارته.",
      body: "يتشارك المنتجان نهجًا واحدًا: يؤدي الذكاء الاصطناعي مهمة محددة داخل مسار العمل الذي تستخدمه بالفعل.",
      points: [
        { title: "المساعدة", description: "يقترح الخطوات التالية على سجلاتك ويصوغ الأجزاء الروتينية، فتبدأ المهام وقد أُنجز نصفها." },
        { title: "التصنيف", description: "يفرز السجلات والفرص ويَسِمها لتصل إلى مكانها الصحيح دون أرشفة يدوية." },
        { title: "ترتيب الأولويات", description: "يُبرز ما يحتاج إلى الاهتمام أولًا، من مهمة امتثال مستحقة إلى أقوى فرصة." },
      ],
    },
    services: {
      heading: "نفس تفكير المنتج، مطبَّق على مشروعك.",
      body: "يتولى الفريق الذي يبني Tetri Copilot وTetri Engage عددًا محدودًا من مشاريع العملاء، بالمعايير الهندسية نفسها.",
      cta: "ناقش مشروعًا",
      items: [
        { title: "برمجيات مخصصة وSaaS", description: "بوابات وأنظمة داخلية ولوحات معلومات ومنتجات SaaS تُبنى من الصفر." },
        { title: "الذكاء الاصطناعي والأتمتة", description: "ميزات ذكاء اصطناعي داخل برمجياتك الحالية، وأتمتة لمسارات العمل المتكررة." },
        { title: "مواقع وأنظمة تصميم", description: "مواقع تسويقية مبرمجة خصيصًا وأنظمة تصميم قابلة لإعادة الاستخدام، سريعة وجاهزة لمحركات البحث." },
        { title: "التكاملات والاستشارات", description: "تكاملات واجهات البرمجة والدفع، وبنية سحابية، وتحديث تقني." },
      ],
      processLabel: "كيف يسير المشروع",
      process: [
        { title: "الاستكشاف", description: "تحديد المشكلة والنتيجة المطلوبة." },
        { title: "التصميم", description: "تشكيل المنتج قبل كتابة الشيفرة." },
        { title: "البناء", description: "إطلاق على مراحل تخضع للمراجعة." },
        { title: "الدعم", description: "التشغيل والقياس والتحسين." },
      ],
    },
    company: {
      heading: "شركة منتجات، مبنية لخدمة الشركات حول العالم.",
      facts: [
        { value: "2", label: "منتجان متاحان في السوق" },
        { value: "4", label: "لغات: الإنجليزية والعربية والجورجية والروسية" },
        { value: "عالميًا", label: "الأسواق ذات الأولوية: جورجيا والإمارات والسعودية والولايات المتحدة" },
        { value: "جورجيا", label: "Tetri Copilot LLC، مسجّلة في جورجيا" },
      ],
      trust: [
        { title: "برمجيات سحابية آمنة.", description: "مبنيّة على بنية تحتية سحابية حديثة ومُدارة." },
        { title: "تصميم يراعي الخصوصية.", description: "يجمع كل منتج ما يحتاجه فعليًا فقط." },
        { title: "اشتراكات شفافة.", description: "أسعار واضحة دون شروط خفية." },
      ],
    },
    finalCta: {
      heading: "اعثر على منتج Tetri الذي يناسب المرحلة التالية من نمو شركتك.",
      body: "استكشف Tetri Copilot وTetri Engage، أو أخبرنا بما تحتاجه شركتك تاليًا.",
      ctaPrimary: "استكشف المنتجات",
      ctaSecondary: "تواصل مع Tetri",
    },
  },

  about: {
    hero: {
      eyebrow: "الشركة",
      heading: "الشركة القائمة على عائلة منتجات Tetri.",
      subheading: "تصمّم Tetri Copilot LLC وتطوّر وتشغّل برمجيات أعمال ذكية — وتقدّم خدمات تطوير مختارة لعدد محدود من العملاء.",
    },
    statement: {
      heading: "ماذا نفعل",
      body: [
        "Tetri Copilot LLC شركة منتجات برمجية. نبني ونملك وندير عائلة تطبيقات الأعمال Tetri، بدءًا من Tetri Copilot وTetri Engage.",
        "نعمل أيضًا مع عدد مختار من العملاء في مشاريع البرمجيات والذكاء الاصطناعي وتطوير الويب — بتطبيق نفس انضباط المنتج الذي نطبّقه على برمجياتنا الخاصة.",
      ],
    },
    builds: {
      heading: "ما الذي تبنيه Tetri",
      body: "يركّز كل منتج من منتجات Tetri على مجال محدد من عمليات الأعمال، ضمن نهج مشترك في البساطة والأتمتة الذكية والتصميم الحديث للبرمجيات.",
      points: [
        { title: "Tetri Copilot", description: "إدارة أعمال وعمليات مالية وامتثال مدعومة بالذكاء الاصطناعي للشركات الصغيرة والمتوسطة." },
        { title: "Tetri Engage", description: "اكتشاف فرص وترتيب أولويات ومتابعات مدعومة بالذكاء الاصطناعي للفرق المتنامية." },
      ],
    },
    vision: {
      heading: "لماذا وُجدت Tetri",
      body: "تتراكم لدى الشركات المتنامية أعمال تشغيلية أسرع مما تستطيع التوظيف لمواجهتها — سجلات متناثرة، ومتابعات ضائعة، وأتمتة تزيد التعقيد بدل أن تزيله. وُجدت Tetri لتحويل هذا العمل المتناثر إلى برمجيات ذكية ومركّزة يمكن لفريق صغير إدارتها فعليًا.",
    },
    principles: {
      eyebrow: "كيف نبني",
      heading: "المبادئ التي تقوم عليها منتجات Tetri جميعها.",
      items: [
        { title: "ذكاء عملي", description: "يجب أن يقلّل الذكاء الاصطناعي العمل، لا أن ينشئ أنظمة جديدة لإدارتها." },
        { title: "البساطة", description: "يجب أن تتحوّل المشكلات التشغيلية المعقدة إلى برمجيات مفهومة." },
        { title: "أتمتة مفيدة", description: "يجب أن تزيل الأتمتة العمل المتكرر حيثما تخلق قيمة حقيقية." },
        { title: "الجودة", description: "التصميم والهندسة والأداء والموثوقية عناصر مهمة في كل إصدار." },
        { title: "الثقة", description: "يجب أن تكون برمجيات الأعمال موثوقة وآمنة وشفافة." },
        { title: "التحسين المستمر", description: "تتطور المنتجات استنادًا إلى احتياجات العملاء الفعلية، لا التخمين." },
      ],
    },
    international: {
      heading: "أين نعمل",
      body: "صُمِّمت Tetri كعائلة منتجات دولية، مع التركيز على هذه الأسواق.",
      markets: [
        { code: "GE", name: "جورجيا", note: "السوق الأساسي ومقر التشغيل" },
        { code: "AE", name: "الإمارات العربية المتحدة", note: "سوق نمو ذو أولوية" },
        { code: "SA", name: "المملكة العربية السعودية", note: "سوق نمو ذو أولوية" },
        { code: "US", name: "الولايات المتحدة", note: "سوق نمو ذو أولوية" },
        { code: "GCC", name: "دول مجلس التعاون الخليجي", note: "تركيز إقليمي آخذ في التوسع" },
        { code: "Global", name: "حول العالم", note: "متاحة للشركات في أي دولة" },
      ],
    },
    technology: {
      heading: "كيف نبني منتجاتنا",
      body: "بُني كل منتج من منتجات Tetri على تقنيات حديثة وقابلة للصيانة — لتبقى موثوقة مع نمو عائلة المنتجات.",
      points: [
        "تطبيقات ويب حديثة",
        "بنية سحابية قابلة للتوسّع",
        "تكاملات مبنية على واجهات برمجة التطبيقات (API)",
        "ذكاء اصطناعي يُستخدم حيث يخلق قيمة قابلة للقياس",
        "الأمان والخصوصية مأخوذان بعين الاعتبار منذ البداية",
      ],
    },
    legal: {
      heading: "المعلومات المؤسسية",
      body: "Tetri Copilot LLC هي الكيان القانوني القائم على عائلة منتجات Tetri والخدمات الموضحة في هذا الموقع.",
      entityLabel: "الكيان القانوني",
      entityValue: "Tetri Copilot LLC",
      jurisdictionLabel: "مسجّلة في",
      jurisdictionValue: "جورجيا",
      contactLabel: "استفسارات الأعمال",
    },
    cta: {
      heading: "تريد معرفة المزيد عن Tetri؟",
      body: "استكشف ما نبنيه، أو تواصل معنا مباشرة.",
      ctaPrimary: "استكشف المنتجات",
      ctaSecondary: "تواصل معنا",
    },
  },

  products: {
    compare: {
      heading: "أي منتج من Tetri يناسبك؟",
      focusLabel: "المهمة الأساسية",
      audienceLabel: "مصمَّم لـ",
      outcomeLabel: "ما الذي يتغير",
      capabilitiesLabel: "القدرات",
    },
    hero: {
      eyebrow: "المنتجات",
      heading: "عائلة منتجات Tetri.",
      subheading: "منتجان مركّزان، تبنيهما وتديرهما Tetri Copilot LLC، ويجمعهما نهج واحد في البساطة والأتمتة الذكية والتصميم الحديث للبرمجيات.",
    },
    list: [
      {
        name: "Tetri Copilot",
        tagline: "الشؤون المالية والتشغيل بلا تعقيد",
        outcome: "وقت أقل في الأعمال الورقية، ووقت أكبر لإدارة العمل.",
        description: "إدارة أعمال مدعومة بالذكاء الاصطناعي للشركات الصغيرة والمتوسطة — الفواتير والمصروفات والسجلات ومتابعة الامتثال والتقارير في مساحة عمل حديثة واحدة.",
        capabilities: ["الفواتير", "المصروفات", "سجلات الأعمال", "متابعة الامتثال", "التقارير", "مساعدة الذكاء الاصطناعي"],
        audience: "أصحاب الشركات الصغيرة والمتوسطة، وفرق المالية والعمليات",
        ctaLabel: "استكشف Tetri Copilot",
      },
      {
        name: "Tetri Engage",
        tagline: "فرص مرتّبة حسب الأولوية",
        outcome: "فرص أقل تضيع بسبب صندوق بريد ممتلئ.",
        description: "اكتشاف فرص وتواصل مدعومان بالذكاء الاصطناعي للفرق المتنامية — اكتشف الفرص، ورتّب الأولويات، وأبقِ المتابعات منظّمة.",
        capabilities: ["اكتشاف الفرص", "الإشارات", "ترتيب الأولويات", "المتابعات", "مسارات التواصل", "مساعدة الذكاء الاصطناعي"],
        audience: "فرق المبيعات والفرق التي تتعامل مع العملاء",
        ctaLabel: "استكشف Tetri Engage",
      },
    ],
    philosophy: {
      heading: "عائلة واحدة، فلسفة واحدة",
      body: "يركّز كل منتج من منتجات Tetri على مجال محدد من عمليات الأعمال، ضمن نهج مشترك في البساطة والأتمتة الذكية والتصميم الحديث للبرمجيات — بحيث تبقى التجربة متسقة أيًّا كان المنتج الذي تستخدمه.",
    },
    future: {
      heading: "مصمَّمة للنمو",
      body: "صُمِّمت بنية منتجات Tetri لاستيعاب منتجات جديدة عند الإعلان عنها، دون إعادة تصميم طريقة عمل العائلة معًا.",
    },
    cta: {
      heading: "هل تريد التعرّف على منتج Tetri عن قرب؟",
      body: "زُر الموقع المخصص للمنتج للاطلاع على كامل التفاصيل، أو تواصل معنا لأي استفسار.",
      ctaLabel: "تواصل مع Tetri",
    },
  },

  copilotPage: {
    eyebrow: "Tetri Copilot",
    heading: "إدارة أعمال لا تقف في طريقك.",
    intro: "يساعد Tetri Copilot الشركات الصغيرة والمتنامية على تنظيم الفواتير والمصروفات والسجلات وأنشطة الامتثال والتقارير والإدارة اليومية في مساحة عمل حديثة واحدة.",
    problemHeading: "المشكلة",
    problemBody: "تميل إدارة الأعمال إلى التشتت بين جداول البيانات والبريد الإلكتروني وأدوات غير مترابطة — فتبقى الفواتير دون متابعة، وتُسجَّل المصروفات متأخرة، وتُكتشف مواعيد الامتثال في اللحظة الأخيرة. يجمع Tetri Copilot هذا العمل كله في مكان واحد.",
    capabilitiesHeading: "ما الذي يقدّمه Tetri Copilot",
    capabilities: [
      { title: "الفواتير", description: "أنشئ الفواتير وأرسلها وتابعها دون مغادرة مساحة العمل." },
      { title: "المصروفات", description: "سجّل مصروفات الشركة ونظّمها فور حدوثها." },
      { title: "سجلات الأعمال", description: "حافظ على تنظيم معلومات الشركة الأساسية وسهولة الوصول إليها." },
      { title: "متابعة الامتثال", description: "تابع أنشطة الامتثال المتكررة ومواعيدها النهائية." },
      { title: "التقارير", description: "حوّل السجلات اليومية إلى تقارير واضحة وقابلة للاستخدام." },
      { title: "مساعدة الذكاء الاصطناعي", description: "يساعد الذكاء الاصطناعي في البحث والتصنيف والصياغة — ما يقلّل العمل الإداري اليدوي." },
    ],
    outcomesHeading: "ما الذي يتغيّر",
    outcomes: [
      "سجلات الأعمال في مساحة عمل واحدة منظّمة بدلًا من أدوات متناثرة",
      "إعداد الفواتير وتتبع المصروفات في دقائق لا ساعات",
      "مواعيد الامتثال مرئية قبل أن تصبح عاجلة",
      "التقارير تعكس معلومات حقيقية ومحدَّثة",
    ],
    aiHeading: "دور الذكاء الاصطناعي",
    aiBody: "يستخدم Tetri Copilot الذكاء الاصطناعي للمساعدة في الإدارة اليومية — إيجاد السجلات وتصنيف المصروفات وصياغة المستندات الروتينية — بحيث يقضي الفريق وقتًا أقل في إدخال البيانات يدويًا.",
    audienceHeading: "لمن هذا المنتج",
    audiences: ["أصحاب الشركات الصغيرة والمتوسطة ومديروها", "فرق المالية والعمليات", "الشركات المتنامية التي تستبدل جداول البيانات"],
    scopeNote: "ينظّم Tetri Copilot سجلات الأعمال والفواتير ومتابعة الامتثال. وهو لا يحتفظ بأموال العملاء أو يعالجها، ولا يعمل كبنك أو مؤسسة دفع، ولا يقدّم خدمات إقراض أو استشارات استثمارية.",
    ctaHeading: "تعرّف على Tetri Copilot بالتفصيل",
    ctaBody: "هذه الصفحة نظرة عامة مؤسسية. زُر موقع Tetri Copilot الرسمي للاطلاع على المنتج كاملًا.",
    ctaLabel: "زيارة Tetri Copilot",
    relatedHeading: "منتجات ذات صلة",
  },

  engagePage: {
    flowHeading: "كيف يعمل Tetri Engage",
    eyebrow: "Tetri Engage",
    heading: "من الإشارة إلى المتابعة، بجهد يدوي أقل.",
    intro: "يساعد Tetri Engage الفرق المتنامية على اكتشاف الفرص الواعدة، وترتيب الأولويات، وتنظيم المتابعات، وتقليل العمل المتكرر في التواصل مع العملاء.",
    problemHeading: "المشكلة",
    problemBody: "تضيع الفرص الواعدة وسط زحمة صندوق البريد، ولا تتوسّع المتابعة اليدوية بشكل جيد مع نمو الفريق. يحوّل Tetri Engage الإشارات المتناثرة إلى مسار عمل منظَّم ومرتَّب حسب الأولوية.",
    capabilitiesHeading: "ما الذي يقدّمه Tetri Engage",
    capabilities: [
      { title: "اكتشاف الفرص", description: "اكتشف الفرص الواعدة قبل أن تضيع." },
      { title: "الإشارات", description: "حوّل النشاط ذا الصلة إلى إشارات قابلة للتنفيذ." },
      { title: "ترتيب أولويات الفرص", description: "اعرف ما يستحق الاهتمام أولًا." },
      { title: "المتابعات", description: "أبقِ كل متابعة منظّمة وفي موعدها." },
      { title: "مسارات التواصل", description: "نظّم عملية التواصل دون أعمال يدوية روتينية." },
      { title: "مساعدة الذكاء الاصطناعي", description: "يساعد الذكاء الاصطناعي في التأهيل وترتيب الأولويات وصياغة رسائل التواصل." },
    ],
    outcomesHeading: "ما الذي يتغيّر",
    outcomes: [
      "تُكتشف الفرص وتُنظَّم بدلًا من أن تضيع",
      "يعرف الفريق بما يبدأ أولًا",
      "تحدث المتابعات وفق جدول زمني، لا اعتمادًا على الذاكرة",
      "عمل يدوي متكرر أقل",
    ],
    aiHeading: "دور الذكاء الاصطناعي",
    aiBody: "يستخدم Tetri Engage الذكاء الاصطناعي للمساعدة في تأهيل الفرص وترتيب الأولويات وصياغة رسائل المتابعة — مع بقاء القرار النهائي دائمًا بيد الفريق.",
    audienceHeading: "لمن هذا المنتج",
    audiences: ["فرق المبيعات والفرق التي تتعامل مع العملاء", "الفرق المتنامية التي لا تملك وظيفة تشغيل مخصصة", "الفرق التي تعتمد اليوم على المتابعة اليدوية"],
    scopeNote: "يدعم Tetri Engage اكتشاف الفرص والمتابعة المنظّمة. وهو لا يضمن نتائج مبيعات أو جودة عملاء محتملين، ولا يجري جمعًا غير مقيَّد للبيانات، ولا يرسل تواصلًا مستقلًا بالكامل دون إشراف الفريق.",
    ctaHeading: "تعرّف على Tetri Engage بالتفصيل",
    ctaBody: "هذه الصفحة نظرة عامة مؤسسية. زُر موقع Tetri Engage الرسمي للاطلاع على المنتج كاملًا.",
    ctaLabel: "زيارة Tetri Engage",
    relatedHeading: "منتجات ذات صلة",
  },

  services: {
    hero: {
      eyebrow: "الخدمات",
      heading: "نفس تفكير المنتج، مطبَّق على مشروعك.",
      subheading: "تبني Tetri Copilot LLC منتجَي Tetri Copilot وTetri Engage كمنتجاتها الخاصة — وتطبّق الانضباط الهندسي نفسه على عدد مختار من مشاريع العملاء.",
    },
    categories: [
      {
        slug: "saas-development",
        title: "تطوير منتجات SaaS",
        summary: "تصميم وتطوير شامل لتطبيقات SaaS، من الإصدار الأول إلى التطوير المستمر.",
        outcomes: ["منتج SaaS جاهز للإنتاج", "بنية مصمَّمة للتوسّع مع الاستخدام الفعلي", "قاعدة كود قابلة للصيانة يمكن لفريقك تطويرها"],
      },
      {
        slug: "ai-automation",
        title: "تفعيل الذكاء الاصطناعي والأتمتة",
        summary: "ميزات ذكاء اصطناعي عملية وأتمتة لمسارات العمل، تُضاف إلى برمجيات جديدة أو قائمة.",
        outcomes: ["مساعدة ذكاء اصطناعي مدمجة في مسارات عمل حقيقية", "أتمتة للمهام المتكررة فعليًا", "بحث وتصنيف وترتيب أولويات ذكي"],
      },
      {
        slug: "web-development",
        title: "تطوير تطبيقات الويب المخصصة",
        summary: "بوابات ولوحات تحكم وأدوات داخلية مصمَّمة وفق طريقة عمل شركتك الفعلية.",
        outcomes: ["أداة مصمَّمة حول مسار عملك، لا قالبًا جاهزًا", "تكامل نظيف مع الأنظمة القائمة", "واجهة سيستخدمها فريقك بالفعل"],
      },
      {
        slug: "business-automation",
        title: "أتمتة العمليات التجارية",
        summary: "إزالة العمل اليدوي المتكرر من العمليات التشغيلية عبر أتمتة موجَّهة.",
        outcomes: ["خطوات يدوية متكررة أقل", "عمليات تعمل باتساق", "وقت مُعاد توجيهه نحو عمل أعلى قيمة"],
      },
      {
        slug: "website-development",
        title: "تصميم وتطوير المواقع",
        summary: "مواقع أعمال وSaaS مبرمجة خصيصًا وعالية الأداء، مصمَّمة للمصداقية والتحويل.",
        outcomes: ["موقع سريع واحترافي وموثوق", "نظام تصميم قابل لإعادة الاستخدام للصفحات المستقبلية", "بنية جاهزة لمحركات البحث منذ اليوم الأول"],
      },
      {
        slug: "consulting-support",
        title: "الاستشارات البرمجية والدعم الفني",
        summary: "استشارات فنية، ومراجعات للبنية التقنية، ودعم مستمر للبرمجيات القائمة.",
        outcomes: ["توجيه فني واضح وعملي", "بنية تقنية راجعها فريق منتجات ذو خبرة", "دعم مستمر يمكنك الاعتماد عليه"],
      },
    ],
    approach: {
      eyebrow: "كيف نعمل",
      heading: "عقلية المنتج، مطبَّقة على مشروعك.",
      body: "نتعامل مع كل مشروع بالطريقة نفسها التي نتعامل بها مع منتجاتنا — بدءًا من النتيجة، لا من قائمة الميزات.",
      steps: [
        { title: "الفهم", description: "نبدأ بفهم مشكلة العمل، لا مجرد المتطلبات الفنية." },
        { title: "التصميم والبناء", description: "نصمّم ونبني وفق المعايير نفسها المستخدمة في Tetri Copilot وTetri Engage." },
        { title: "الدعم", description: "نبقى مشاركين بعد الإطلاق، لتستمر البرمجيات بالعمل مع تطوّر أعمالك." },
      ],
    },
    proof: {
      heading: "بناه الفريق القائم على Tetri Copilot وTetri Engage",
      body: "تنبع قدرتنا في تقديم الخدمات مباشرة من بناء منتجاتنا وتشغيلها — المعايير الهندسية نفسها، مطبَّقة على مشروعك.",
    },
    faq: {
      heading: "أسئلة شائعة",
      items: [
        { question: "هل تقبل Tetri Copilot LLC كل مشروع؟", answer: "لا. نعمل مع عدد محدود من العملاء في الوقت نفسه ليحظى كل مشروع باهتمام حقيقي من فريق المنتج." },
        { question: "هل هذا الفريق نفسه الذي يبني Tetri Copilot وTetri Engage؟", answer: "نعم. تُقدَّم الخدمات من الفريق نفسه وبالمعايير الهندسية نفسها المستخدمة في منتجاتنا." },
        { question: "هل يمكن أن تتكامل الخدمات مع Tetri Copilot أو Tetri Engage؟", answer: "في كثير من الحالات، نعم — تواصل معنا لنناقش ما يناسب إعدادك." },
      ],
    },
    cta: {
      heading: "لديك مشروع في ذهنك؟",
      body: "أخبرنا عنه وسنعلمك إن كان مناسبًا لنا.",
      ctaLabel: "ناقش مشروعك",
    },
  },

  contact: {
    hero: {
      eyebrow: "تواصل معنا",
      heading: "لنتحدث عمّا تحتاجه.",
      subheading: "أسئلة عن المنتجات، أو أفكار للشراكة، أو مشروع تريد مناقشته — يسعدنا أن نسمع منك.",
    },
    reasons: [
      { title: "استفسارات المنتجات", description: "أسئلة حول Tetri Copilot أو Tetri Engage." },
      { title: "الشراكات", description: "فرص شراكة إحالة أو إعادة بيع أو شراكة تقنية." },
      { title: "الخدمات", description: "مشاريع برمجيات أو ذكاء اصطناعي أو تطوير مواقع." },
      { title: "أي شيء آخر", description: "استفسارات إعلامية أو عن الشركة، أو أي موضوع غير مذكور أعلاه." },
    ],
    info: {
      heading: "التواصل المباشر",
      emailLabel: "البريد الإلكتروني",
      phoneLabel: "الهاتف",
      phones: ["+995 55 000 4769", "+995 511 415 313"],
      locationLabel: "المقر",
      locationValue: "جورجيا — نخدم جورجيا والإمارات والسعودية والولايات المتحدة وحول العالم",
    },
    form: {
      heading: "أرسل لنا رسالة",
      nameLabel: "الاسم",
      namePlaceholder: "اسمك الكامل",
      emailLabel: "البريد الإلكتروني للعمل",
      emailPlaceholder: "you@company.com",
      companyLabel: "الشركة",
      companyPlaceholder: "اسم شركتك",
      inquiryTypeLabel: "نوع الاستفسار",
      inquiryTypePlaceholder: "اختر نوع الاستفسار",
      inquiryTypes: [
        { value: "product", label: "استفسار عن منتج" },
        { value: "sales-demo", label: "مبيعات / عرض توضيحي" },
        { value: "partnership", label: "شراكة" },
        { value: "software-development", label: "تطوير برمجيات" },
        { value: "ai-automation", label: "ذكاء اصطناعي / أتمتة" },
        { value: "website-development", label: "تطوير موقع" },
        { value: "media", label: "إعلام / عن الشركة" },
        { value: "other", label: "أخرى" },
      ],
      countryLabel: "الدولة (اختياري)",
      countryPlaceholder: "دولتك",
      messageLabel: "الرسالة",
      messagePlaceholder: "أخبرنا قليلًا عمّا تحتاجه.",
      privacyNotice: "بالإرسال، فإنك توافق على سياسة الخصوصية الخاصة بنا. نستخدم بياناتك فقط للرد على استفسارك.",
      submit: "إرسال الرسالة",
      submitting: "جارٍ الإرسال…",
      successHeading: "تم إرسال الرسالة.",
      successBody: "شكرًا لك — لقد استلمنا رسالتك وسنتواصل معك قريبًا.",
      errorHeading: "حدث خطأ ما.",
      errorBody: "لم يتم إرسال رسالتك. يرجى المحاولة مجددًا أو مراسلتنا مباشرة عبر البريد الإلكتروني.",
      retry: "أعد المحاولة",
      devModeHeading: "نموذج التواصل غير مفعّل بعد",
      devModeBody: "لا تحتوي هذه البيئة على عنوان مهيّأ لاستقبال النموذج، لذا لا يمكن إرسال الرسائل. عيّن VITE_CONTACT_FORM_ENDPOINT (راجع .env.example) لتفعيله.",
      validation: {
        required: "هذا الحقل مطلوب.",
        invalidEmail: "أدخل بريدًا إلكترونيًا صحيحًا.",
        tooShort: "يرجى إضافة مزيد من التفاصيل.",
      },
    },
  },

  legal: {
    privacy: {
      title: "سياسة الخصوصية",
      updated: "آخر تحديث: سبتمبر 2026",
      intro: "توضّح هذه السياسة المعلومات التي تجمعها Tetri Copilot LLC عبر هذا الموقع وكيفية استخدامها. تنطبق فقط على موقع tetricopilot.com المؤسسي؛ وقد يكون لمنتجَي Tetri Copilot وTetri Engage إشعارات خصوصية خاصة بهما.",
      sections: [
        { title: "المعلومات التي نجمعها", description: "عند إرسال نموذج التواصل، نجمع المعلومات التي تقدّمها — مثل اسمك وبريدك الإلكتروني للعمل واسم شركتك ورسالتك. لا حاجة لإنشاء حساب لتصفح هذا الموقع." },
        { title: "كيفية استخدام المعلومات", description: "نستخدم بيانات نموذج التواصل فقط للرد على استفسارك والاحتفاظ بسجل للمراسلات التجارية. لا نبيع المعلومات الشخصية لأطراف ثالثة." },
        { title: "ملفات تعريف الارتباط والتحليلات", description: "قد يستخدم هذا الموقع ملفات تعريف ارتباط أساسية للوظائف الجوهرية وتحليلات تراعي الخصوصية لفهم الاستخدام العام للموقع. راجع سياسة ملفات تعريف الارتباط للتفاصيل." },
        { title: "الاحتفاظ بالبيانات", description: "نحتفظ برسائل التواصل للمدة اللازمة بشكل معقول للرد عليها وتوثيق المراسلات التجارية." },
        { title: "حقوقك", description: "يمكنك طلب الوصول إلى المعلومات التي أرسلتها إلينا أو تصحيحها أو حذفها عبر مراسلتنا على info@tetricopilot.com." },
        { title: "التواصل", description: "يمكن إرسال الأسئلة حول هذه السياسة إلى info@tetricopilot.com." },
      ],
    },
    terms: {
      title: "شروط الخدمة",
      updated: "آخر تحديث: سبتمبر 2026",
      intro: "تحكم هذه الشروط استخدامك لموقع Tetri Copilot LLC المؤسسي. يخضع استخدام منتجات Tetri الفردية (Tetri Copilot وTetri Engage) لشروطها الخاصة، المتاحة على مواقعها الخاصة.",
      sections: [
        { title: "استخدام هذا الموقع", description: "يُقدَّم هذا الموقع للتعريف بشركة Tetri Copilot LLC وعائلة منتجات Tetri وخدماتنا. توافق على استخدامه للأغراض المشروعة فقط." },
        { title: "الملكية الفكرية", description: "اسم Tetri وشعاره ومحتوى هذا الموقع ملك لشركة Tetri Copilot LLC، ولا يجوز استخدامها دون إذن." },
        { title: "عدم وجود ضمان", description: "يُقدَّم هذا الموقع ومحتواه \"كما هو\" دون أي ضمانات، إلى الحد الذي يسمح به القانون." },
        { title: "تحديد المسؤولية", description: "لا تتحمل Tetri Copilot LLC مسؤولية الأضرار غير المباشرة أو التبعية الناشئة عن استخدام هذا الموقع، إلى الحد الذي يسمح به القانون." },
        { title: "تعديلات هذه الشروط", description: "قد نُحدّث هذه الشروط من وقت لآخر. يُعدّ استمرار استخدام الموقع موافقةً على الشروط السارية." },
        { title: "التواصل", description: "يمكن إرسال الأسئلة حول هذه الشروط إلى info@tetricopilot.com." },
      ],
    },
    cookies: {
      title: "سياسة ملفات تعريف الارتباط",
      updated: "آخر تحديث: سبتمبر 2026",
      intro: "توضّح هذه السياسة كيفية استخدام Tetri Copilot LLC لملفات تعريف الارتباط والتقنيات المشابهة على هذا الموقع.",
      sections: [
        { title: "الملفات التي نستخدمها", description: "نستخدم ملفات تعريف ارتباط أساسية ضرورية لعمل الموقع بشكل صحيح، وقد نستخدم ملفات تحليلية تراعي الخصوصية لفهم الاستخدام العام للموقع." },
        { title: "إدارة ملفات تعريف الارتباط", description: "تتيح لك معظم المتصفحات التحكم في ملفات تعريف الارتباط أو تعطيلها من الإعدادات. قد يؤثر تعطيل الملفات الأساسية على عمل بعض أجزاء الموقع." },
        { title: "ملفات تعريف الارتباط من أطراف ثالثة", description: "لا نسمح بملفات تعريف ارتباط إعلانية من أطراف ثالثة على هذا الموقع." },
        { title: "التواصل", description: "يمكن إرسال الأسئلة حول هذه السياسة إلى info@tetricopilot.com." },
      ],
    },
  },

  notFound: {
    eyebrow: "404",
    heading: "هذه الصفحة غير موجودة.",
    body: "الصفحة التي تبحث عنها ربما نُقلت أو لم تكن موجودة من الأساس. إليك بعض الوجهات المفيدة بدلًا منها.",
    ctaHome: "الرئيسية",
    ctaProducts: "المنتجات",
    ctaContact: "تواصل معنا",
  },
};

export default ar;
